import { Instance, SnapshotOut, types } from "mobx-state-tree"
import {Timestamp} from "firebase/firestore";

/**
 * Rick and Morty character model.
 */
export const ProjectModel = types.model("Project").props({
  id: types.maybe(types.string),
  businessId: types.string,
  name: types.string,
  apiKey: types.string,
  walletAddress: types.string,
  createdAt: types.maybe(types.string),
  updatedAt: types.maybe(types.string)
})

type ProjectType = Instance<typeof ProjectModel>
export interface Project extends ProjectType {}
type ProjectSnapshotType = SnapshotOut<typeof ProjectModel>
export interface ProjectSnapshot extends ProjectSnapshotType {}

export const projectFromJson = (docData) => {
  const updatedAtTimeStamp: Timestamp | string | undefined = docData.updatedAt;
  const createdAtTimeStamp: Timestamp | string | undefined = docData.createdAt;

  console.log("projectFromJson", docData)

  return {
    id: docData.id,
    businessId: docData.businessId,
    name: docData.name,
    apiKey: docData.apiKey,
    walletAddress: docData.walletAddress,
    createdAt: createdAtTimeStamp instanceof Timestamp ? createdAtTimeStamp.toDate().toDateString() : createdAtTimeStamp,
    updatedAt: updatedAtTimeStamp instanceof Timestamp ? updatedAtTimeStamp.toDate().toDateString() : updatedAtTimeStamp
  }
}
